// ---------------------------------------------------------------------------
// PWA Caisse Tablette — Full-screen loading spinner overlay
// ---------------------------------------------------------------------------

export default function LoadingSpinner() {
  return (
    <div className="fixed inset-0 z-[9990] bg-surface/90 flex flex-col items-center justify-center">
      <div className="w-12 h-12 border-4 border-gray-600 border-t-accent rounded-full animate-spin-slow" />
      <p className="mt-4 text-gray-400 text-sm">Connexion au serveur...</p>
    </div>
  );
}
